module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch7"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch7.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-7"
    }
  }, [_vm._v("You stare at the thing under the covers. Your heart beats triple time.")])]), _c('a', {
    attrs: {
      "id": "pg-7"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What is it? A boy? A dog?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or a little bit of each?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Help me,” he says again. “Please. My name is Joseph. Dr. Eeek tried to turn me into a German shepherd, but it didn’t work. So now he’s trying to turn me back into a kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You don’t know what to say. This is so creepy — so sick! How could your mother work in a place like this?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m strapped down,” the boy explains. He gestures toward his hairy, doggy arms. “Loosen the straps so I can get free.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” you say. Your stomach lurches at the sight of bristly dog hair all over this kid’s body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You start to undo the straps. But before you can finish, you hear footsteps approaching.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quick! You’d better find a place to hide!")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-7"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you hide in Dr. Eeek’s office on the other side of the room, turn to")])]), _c('span', {
    attrs: {
      "href": "#/e9780545841054_ch129",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 129")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you hide under the operating table, turn to")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/e9780545841054_ch074",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 74")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8da448c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841054_ch007.vue
// module id = 84
// module chunks = 0